import constructionPartnerTranslations from "./constructionPartnerTranslations";

const clone = (value) => JSON.parse(JSON.stringify(value));

const investorOwnershipTranslations = Object.fromEntries(
  ["en", "pt", "zh", "fr", "es", "de", "it", "ru"].map((language) => [
    language,
    clone(constructionPartnerTranslations[language]),
  ])
);

Object.assign(investorOwnershipTranslations.en, {
  navigation: "Investor & Ownership Intelligence",
  eyebrow: "Panatlantik public-source intelligence",
  title: "Investor & Ownership Intelligence",
  subtitle: "Evidence-led profiles of family offices, investment companies, funds, institutional investors, owners and strategic real-estate capital.",
  addProfile: "Add intelligence profile",
  discover: "Discover public profiles",
  total: "Total profiles",
  priorityA: "Priority A profiles",
  verified: "Officially verified",
  portugal: "Targeting Portugal",
  search: "Search investor, organisation, geography or sector…",
  allProfileTypes: "All profile types",
  allSectors: "All investment sectors",
  sectors: "Investment sectors",
  contactMissing: "Professional contact requires review",
  officialWebsite: "Official website",
  portugalPresence: "Portugal investment interest",
  loading: "Loading investor intelligence…",
  loadError: "Investor intelligence could not be loaded.",
  noResults: "No investor or ownership profiles found.",
  noResultsHelp: "Adjust the filters or discover profiles from approved public sources.",
  noDescription: "No public-source description recorded.",
  notice: "Public-source intelligence only. Evidence, lawful basis and outreach status must be reviewed before contact.",
});

Object.assign(investorOwnershipTranslations.en.form, {
  eyebrow: "Evidence-led intelligence profile",
  title: "Add Investor or Ownership Profile",
  companyInformation: "Organisation and investment information",
  name: "Profile or organisation name",
  legalName: "Legal name",
  entityType: "Entity type",
  organisation: "Organisation",
  person: "Public professional",
  country: "Headquarters country",
  city: "Headquarters city",
  website: "Official website",
  role: "Profile type",
  speciality: "Investment sector",
  capability: "Investment strategy",
  investmentGeography: "Target investment geography",
  description: "Public-source description",
  professionalContact: "Public professional contact",
  relevance: "Why this profile is relevant",
  save: "Save intelligence profile",
  saving: "Saving…",
  created: "Investor intelligence profile created.",
  createError: "Investor intelligence profile could not be created.",
});

Object.assign(investorOwnershipTranslations.en.discovery, {
  back: "Back to Investor & Ownership Intelligence",
  eyebrow: "Controlled public-source research",
  title: "Discover Investors & Ownership Signals",
  subtitle: "Research public organisational and professional sources without paid HNWI databases or unsupported personal wealth claims.",
  searchPlaceholder: "Investor, organisation or ownership signal",
  country: "Target country",
  profileType: "Investor profile type",
  allProfileTypes: "All investor profile types",
  strategy: "Investment strategy",
  allStrategies: "All investment strategies",
  officialUrl: "Known official website (optional)",
  search: "Search public sources",
  searching: "Searching…",
  contactReady: "Professional contact complete",
  needsContact: "Professional contact missing",
  email: "Reviewed professional email",
  phone: "Reviewed professional telephone",
  reviewSource: "Review public source",
  imported: "Already imported",
  importing: "Importing…",
  import: "Import profile",
  searchError: "Public investor discovery failed.",
  importSuccess: "Intelligence profile imported for review.",
  importError: "Intelligence profile could not be imported.",
  ruleOfficial: "Review the official organisation or professional source before import.",
  ruleContact: "A public professional email and telephone are required for controlled import.",
  ruleReview: "Discovery remains unverified and outreach-blocked until authorised review.",
  results: "public-source candidates found",
  provider: "Search provider",
  noResults: "No suitable public investor or ownership profiles were found.",
});

Object.assign(investorOwnershipTranslations.pt, {
  navigation: "Inteligência de Investidores e Propriedade",
  eyebrow: "Inteligência Panatlantik de fontes públicas",
  title: "Inteligência de Investidores e Propriedade",
  subtitle: "Perfis baseados em evidências de family offices, sociedades de investimento, fundos, investidores institucionais, proprietários e capital imobiliário estratégico.",
  addProfile: "Adicionar perfil de inteligência",
  discover: "Descobrir perfis públicos",
  total: "Total de perfis",
  priorityA: "Perfis de prioridade A",
  verified: "Verificados oficialmente",
  portugal: "Com interesse em Portugal",
  search: "Pesquisar investidor, organização, geografia ou setor…",
  allProfileTypes: "Todos os tipos de perfil",
  allSectors: "Todos os setores de investimento",
  sectors: "Setores de investimento",
  contactMissing: "O contacto profissional requer revisão",
  officialWebsite: "Website oficial",
  portugalPresence: "Interesse de investimento em Portugal",
  loading: "A carregar inteligência de investidores…",
  loadError: "Não foi possível carregar a inteligência de investidores.",
  noResults: "Não foram encontrados perfis de investidores ou propriedade.",
  noResultsHelp: "Ajustar os filtros ou descobrir perfis em fontes públicas aprovadas.",
  noDescription: "Sem descrição registada de fonte pública.",
  notice: "Apenas inteligência de fontes públicas. As evidências, a base legal e o estado de contacto devem ser revistos antes de qualquer comunicação.",
});

Object.assign(investorOwnershipTranslations.pt.form, {
  eyebrow: "Perfil de inteligência baseado em evidências",
  title: "Adicionar Perfil de Investidor ou Propriedade",
  companyInformation: "Informação da organização e do investimento",
  name: "Nome do perfil ou organização",
  legalName: "Denominação legal",
  entityType: "Tipo de entidade",
  organisation: "Organização",
  person: "Profissional com função pública",
  country: "País da sede",
  city: "Cidade da sede",
  website: "Website oficial",
  role: "Tipo de perfil",
  speciality: "Setor de investimento",
  capability: "Estratégia de investimento",
  investmentGeography: "Geografia-alvo de investimento",
  description: "Descrição baseada em fontes públicas",
  professionalContact: "Contacto profissional público",
  relevance: "Por que este perfil é relevante",
  save: "Guardar perfil de inteligência",
  saving: "A guardar…",
  created: "Perfil de inteligência de investidor criado.",
  createError: "Não foi possível criar o perfil de inteligência.",
});

Object.assign(investorOwnershipTranslations.pt.discovery, {
  back: "Voltar à Inteligência de Investidores e Propriedade",
  eyebrow: "Pesquisa controlada em fontes públicas",
  title: "Descobrir Investidores e Sinais de Propriedade",
  subtitle: "Pesquisar fontes públicas organizacionais e profissionais sem bases HNWI pagas nem alegações de património pessoal sem suporte.",
  searchPlaceholder: "Investidor, organização ou sinal de propriedade",
  country: "País-alvo",
  profileType: "Tipo de perfil de investidor",
  allProfileTypes: "Todos os tipos de investidor",
  strategy: "Estratégia de investimento",
  allStrategies: "Todas as estratégias de investimento",
  officialUrl: "Website oficial conhecido (opcional)",
  search: "Pesquisar fontes públicas",
  searching: "A pesquisar…",
  contactReady: "Contacto profissional completo",
  needsContact: "Contacto profissional em falta",
  email: "Email profissional revisto",
  phone: "Telefone profissional revisto",
  reviewSource: "Rever fonte pública",
  imported: "Já importado",
  importing: "A importar…",
  import: "Importar perfil",
  searchError: "A pesquisa pública de investidores falhou.",
  importSuccess: "Perfil de inteligência importado para revisão.",
  importError: "Não foi possível importar o perfil de inteligência.",
  ruleOfficial: "Rever a fonte oficial da organização ou do profissional antes da importação.",
  ruleContact: "São obrigatórios email e telefone profissionais públicos para a importação controlada.",
  ruleReview: "A descoberta permanece não verificada e bloqueada para contacto até revisão autorizada.",
  results: "candidatos de fontes públicas encontrados",
  provider: "Fornecedor de pesquisa",
  noResults: "Não foram encontrados perfis públicos adequados de investidores ou propriedade.",
});

// Investor Chinese and French overrides.
Object.assign(investorOwnershipTranslations.zh, {
  navigation: "投资者与所有权情报",
  eyebrow: "Panatlantik 公共来源情报",
  title: "投资者与所有权情报",
  subtitle: "基于证据的家族办公室、投资公司、基金、机构投资者、所有者及战略房地产资本档案。",
  addProfile: "添加情报档案",
  discover: "发现公开档案",
  total: "档案总数",
  priorityA: "A 级优先档案",
  verified: "官方已核实",
  portugal: "关注葡萄牙",
  search: "搜索投资者、机构、地区或行业…",
  allProfileTypes: "所有档案类型",
  allSectors: "所有投资行业",
  sectors: "投资行业",
  contactMissing: "专业联系方式需要审核",
  officialWebsite: "官方网站",
  portugalPresence: "葡萄牙投资意向",
  loading: "正在加载投资者情报…",
  loadError: "无法加载投资者情报。",
  noResults: "未找到投资者或所有权档案。",
  noResultsHelp: "请调整筛选条件，或从获准的公开来源发现档案。",
  noDescription: "尚未记录公开来源说明。",
  notice: "仅限公共来源情报。联系前必须审核证据、合法依据和外联状态。",
});
Object.assign(investorOwnershipTranslations.zh.form, {
  eyebrow: "基于证据的情报档案",
  title: "添加投资者或所有权档案",
  companyInformation: "机构与投资信息",
  name: "档案或机构名称",
  legalName: "法定名称",
  entityType: "实体类型",
  organisation: "机构",
  person: "公开职业人士",
  country: "总部所在国家",
  city: "总部所在城市",
  website: "官方网站",
  role: "档案类型",
  speciality: "投资行业",
  capability: "投资策略",
  investmentGeography: "目标投资地区",
  description: "公共来源说明",
  professionalContact: "公开专业联系方式",
  relevance: "该档案的重要性",
  save: "保存情报档案",
  saving: "正在保存…",
  created: "投资者情报档案已创建。",
  createError: "无法创建投资者情报档案。",
});
Object.assign(investorOwnershipTranslations.zh.discovery, {
  back: "返回投资者与所有权情报",
  eyebrow: "受控公共来源研究",
  title: "发现投资者与所有权信号",
  subtitle: "研究公开机构与职业来源，不使用付费高净值数据库，也不作无证据的个人财富声明。",
  searchPlaceholder: "投资者、机构或所有权信号",
  country: "目标国家",
  profileType: "投资者档案类型",
  allProfileTypes: "所有投资者类型",
  strategy: "投资策略",
  allStrategies: "所有投资策略",
  officialUrl: "已知官方网站（可选）",
  search: "搜索公开来源",
  searching: "正在搜索…",
  contactReady: "专业联系方式完整",
  needsContact: "缺少专业联系方式",
  email: "已审核专业邮箱",
  phone: "已审核专业电话",
  reviewSource: "审核公开来源",
  imported: "已导入",
  importing: "正在导入…",
  import: "导入档案",
  searchError: "公开投资者搜索失败。",
  importSuccess: "情报档案已导入，等待审核。",
  importError: "无法导入情报档案。",
  ruleOfficial: "导入前审核机构或专业人士的官方来源。",
  ruleContact: "受控导入必须提供公开专业邮箱和电话。",
  ruleReview: "在授权审核前，发现结果保持未核实且禁止外联。",
  results: "个公共来源候选档案",
  provider: "搜索提供商",
  noResults: "未找到合适的公开投资者或所有权档案。",
});

Object.assign(investorOwnershipTranslations.fr, {
  navigation: "Intelligence Investisseurs et Propriété",
  eyebrow: "Intelligence Panatlantik de sources publiques",
  title: "Intelligence Investisseurs et Propriété",
  subtitle: "Profils étayés par des preuves de family offices, sociétés d’investissement, fonds, investisseurs institutionnels, propriétaires et capitaux immobiliers stratégiques.",
  addProfile: "Ajouter un profil d’intelligence",
  discover: "Découvrir des profils publics",
  total: "Total des profils",
  priorityA: "Profils de priorité A",
  verified: "Officiellement vérifiés",
  portugal: "Ciblant le Portugal",
  search: "Rechercher investisseur, organisation, zone ou secteur…",
  allProfileTypes: "Tous les types de profil",
  allSectors: "Tous les secteurs d’investissement",
  sectors: "Secteurs d’investissement",
  contactMissing: "Le contact professionnel doit être vérifié",
  officialWebsite: "Site officiel",
  portugalPresence: "Intérêt d’investissement au Portugal",
  loading: "Chargement de l’intelligence investisseurs…",
  loadError: "Impossible de charger l’intelligence investisseurs.",
  noResults: "Aucun profil d’investisseur ou de propriété trouvé.",
  noResultsHelp: "Ajustez les filtres ou recherchez dans les sources publiques approuvées.",
  noDescription: "Aucune description de source publique enregistrée.",
  notice: "Intelligence de sources publiques uniquement. Les preuves, la base légale et le statut de prospection doivent être vérifiés avant tout contact.",
});
Object.assign(investorOwnershipTranslations.fr.form, {
  eyebrow: "Profil d’intelligence fondé sur des preuves",
  title: "Ajouter un Profil Investisseur ou de Propriété",
  companyInformation: "Informations sur l’organisation et l’investissement",
  name: "Nom du profil ou de l’organisation",
  legalName: "Dénomination légale",
  entityType: "Type d’entité",
  organisation: "Organisation",
  person: "Professionnel à fonction publique",
  country: "Pays du siège",
  city: "Ville du siège",
  website: "Site officiel",
  role: "Type de profil",
  speciality: "Secteur d’investissement",
  capability: "Stratégie d’investissement",
  investmentGeography: "Zone géographique d’investissement ciblée",
  description: "Description issue de sources publiques",
  professionalContact: "Contact professionnel public",
  relevance: "Pertinence de ce profil",
  save: "Enregistrer le profil d’intelligence",
  saving: "Enregistrement…",
  created: "Profil d’intelligence investisseur créé.",
  createError: "Impossible de créer le profil d’intelligence.",
});
Object.assign(investorOwnershipTranslations.fr.discovery, {
  back: "Retour à l’Intelligence Investisseurs et Propriété",
  eyebrow: "Recherche contrôlée de sources publiques",
  title: "Découvrir Investisseurs et Signaux de Propriété",
  subtitle: "Rechercher des sources organisationnelles et professionnelles publiques sans bases HNWI payantes ni affirmations patrimoniales personnelles non étayées.",
  searchPlaceholder: "Investisseur, organisation ou signal de propriété",
  country: "Pays ciblé",
  profileType: "Type de profil investisseur",
  allProfileTypes: "Tous les types d’investisseur",
  strategy: "Stratégie d’investissement",
  allStrategies: "Toutes les stratégies d’investissement",
  officialUrl: "Site officiel connu (facultatif)",
  search: "Rechercher les sources publiques",
  searching: "Recherche…",
  contactReady: "Contact professionnel complet",
  needsContact: "Contact professionnel manquant",
  email: "E-mail professionnel vérifié",
  phone: "Téléphone professionnel vérifié",
  reviewSource: "Vérifier la source publique",
  imported: "Déjà importé",
  importing: "Importation…",
  import: "Importer le profil",
  searchError: "La recherche publique d’investisseurs a échoué.",
  importSuccess: "Profil d’intelligence importé pour vérification.",
  importError: "Impossible d’importer le profil d’intelligence.",
  ruleOfficial: "Vérifier la source officielle de l’organisation ou du professionnel avant l’importation.",
  ruleContact: "Un e-mail et un téléphone professionnels publics sont requis pour l’importation contrôlée.",
  ruleReview: "La découverte reste non vérifiée et bloquée pour la prospection jusqu’à une révision autorisée.",
  results: "candidats issus de sources publiques trouvés",
  provider: "Fournisseur de recherche",
  noResults: "Aucun profil public approprié d’investisseur ou de propriété n’a été trouvé.",
});

// Investor Spanish and German overrides.
Object.assign(investorOwnershipTranslations.es, {
  navigation: "Inteligencia de Inversores y Propiedad",
  eyebrow: "Inteligencia Panatlantik de fuentes públicas",
  title: "Inteligencia de Inversores y Propiedad",
  subtitle: "Perfiles respaldados por evidencias de family offices, sociedades de inversión, fondos, inversores institucionales, propietarios y capital inmobiliario estratégico.",
  addProfile: "Añadir perfil de inteligencia",
  discover: "Descubrir perfiles públicos",
  total: "Total de perfiles",
  priorityA: "Perfiles de prioridad A",
  verified: "Verificados oficialmente",
  portugal: "Con interés en Portugal",
  search: "Buscar inversor, organización, geografía o sector…",
  allProfileTypes: "Todos los tipos de perfil",
  allSectors: "Todos los sectores de inversión",
  sectors: "Sectores de inversión",
  contactMissing: "El contacto profesional requiere revisión",
  officialWebsite: "Sitio web oficial",
  portugalPresence: "Interés de inversión en Portugal",
  loading: "Cargando inteligencia de inversores…",
  loadError: "No se pudo cargar la inteligencia de inversores.",
  noResults: "No se encontraron perfiles de inversores o propiedad.",
  noResultsHelp: "Ajuste los filtros o busque perfiles en fuentes públicas aprobadas.",
  noDescription: "No hay descripción registrada de fuente pública.",
  notice: "Solo inteligencia de fuentes públicas. Las evidencias, la base legal y el estado de contacto deben revisarse antes de cualquier comunicación.",
});
Object.assign(investorOwnershipTranslations.es.form, {
  eyebrow: "Perfil de inteligencia basado en evidencias",
  title: "Añadir Perfil de Inversor o Propiedad",
  companyInformation: "Información de la organización y la inversión",
  name: "Nombre del perfil u organización",
  legalName: "Razón social",
  entityType: "Tipo de entidad",
  organisation: "Organización",
  person: "Profesional con función pública",
  country: "País de la sede",
  city: "Ciudad de la sede",
  website: "Sitio web oficial",
  role: "Tipo de perfil",
  speciality: "Sector de inversión",
  capability: "Estrategia de inversión",
  investmentGeography: "Geografía objetivo de inversión",
  description: "Descripción basada en fuentes públicas",
  professionalContact: "Contacto profesional público",
  relevance: "Por qué este perfil es relevante",
  save: "Guardar perfil de inteligencia",
  saving: "Guardando…",
  created: "Perfil de inteligencia de inversor creado.",
  createError: "No se pudo crear el perfil de inteligencia.",
});
Object.assign(investorOwnershipTranslations.es.discovery, {
  back: "Volver a Inteligencia de Inversores y Propiedad",
  eyebrow: "Investigación controlada de fuentes públicas",
  title: "Descubrir Inversores y Señales de Propiedad",
  subtitle: "Investigar fuentes públicas organizativas y profesionales sin bases HNWI de pago ni afirmaciones patrimoniales personales sin respaldo.",
  searchPlaceholder: "Inversor, organización o señal de propiedad",
  country: "País objetivo",
  profileType: "Tipo de perfil de inversor",
  allProfileTypes: "Todos los tipos de inversor",
  strategy: "Estrategia de inversión",
  allStrategies: "Todas las estrategias de inversión",
  officialUrl: "Sitio web oficial conocido (opcional)",
  search: "Buscar fuentes públicas",
  searching: "Buscando…",
  contactReady: "Contacto profesional completo",
  needsContact: "Falta contacto profesional",
  email: "Correo profesional revisado",
  phone: "Teléfono profesional revisado",
  reviewSource: "Revisar fuente pública",
  imported: "Ya importado",
  importing: "Importando…",
  import: "Importar perfil",
  searchError: "Falló la búsqueda pública de inversores.",
  importSuccess: "Perfil de inteligencia importado para revisión.",
  importError: "No se pudo importar el perfil de inteligencia.",
  ruleOfficial: "Revise la fuente oficial de la organización o del profesional antes de importar.",
  ruleContact: "Se requieren correo y teléfono profesionales públicos para la importación controlada.",
  ruleReview: "El descubrimiento permanece sin verificar y bloqueado para contacto hasta una revisión autorizada.",
  results: "candidatos de fuentes públicas encontrados",
  provider: "Proveedor de búsqueda",
  noResults: "No se encontraron perfiles públicos adecuados de inversores o propiedad.",
});

Object.assign(investorOwnershipTranslations.de, {
  navigation: "Investoren- und Eigentümerinformationen",
  eyebrow: "Panatlantik-Informationen aus öffentlichen Quellen",
  title: "Investoren- und Eigentümerinformationen",
  subtitle: "Beleggestützte Profile von Family Offices, Investmentgesellschaften, Fonds, institutionellen Investoren, Eigentümern und strategischem Immobilienkapital.",
  addProfile: "Informationsprofil hinzufügen",
  discover: "Öffentliche Profile entdecken",
  total: "Profile insgesamt",
  priorityA: "Profile mit Priorität A",
  verified: "Offiziell verifiziert",
  portugal: "Portugal im Fokus",
  search: "Investor, Organisation, Region oder Sektor suchen…",
  allProfileTypes: "Alle Profiltypen",
  allSectors: "Alle Investmentsektoren",
  sectors: "Investmentsektoren",
  contactMissing: "Professioneller Kontakt muss geprüft werden",
  officialWebsite: "Offizielle Website",
  portugalPresence: "Investitionsinteresse in Portugal",
  loading: "Investoreninformationen werden geladen…",
  loadError: "Investoreninformationen konnten nicht geladen werden.",
  noResults: "Keine Investoren- oder Eigentümerprofile gefunden.",
  noResultsHelp: "Filter anpassen oder Profile in freigegebenen öffentlichen Quellen suchen.",
  noDescription: "Keine Beschreibung aus öffentlichen Quellen erfasst.",
  notice: "Nur Informationen aus öffentlichen Quellen. Nachweise, Rechtsgrundlage und Kontaktstatus müssen vor jeder Ansprache geprüft werden.",
});
Object.assign(investorOwnershipTranslations.de.form, {
  eyebrow: "Beleggestütztes Informationsprofil",
  title: "Investoren- oder Eigentümerprofil hinzufügen",
  companyInformation: "Organisations- und Investmentinformationen",
  name: "Name des Profils oder der Organisation",
  legalName: "Rechtlicher Name",
  entityType: "Entitätstyp",
  organisation: "Organisation",
  person: "Öffentlich auftretende Fachperson",
  country: "Land des Hauptsitzes",
  city: "Stadt des Hauptsitzes",
  website: "Offizielle Website",
  role: "Profiltyp",
  speciality: "Investmentsektor",
  capability: "Investmentstrategie",
  investmentGeography: "Zielregion für Investitionen",
  description: "Beschreibung aus öffentlichen Quellen",
  professionalContact: "Öffentlicher professioneller Kontakt",
  relevance: "Warum dieses Profil relevant ist",
  save: "Informationsprofil speichern",
  saving: "Speichern…",
  created: "Investorenprofil wurde erstellt.",
  createError: "Informationsprofil konnte nicht erstellt werden.",
});
Object.assign(investorOwnershipTranslations.de.discovery, {
  back: "Zurück zu Investoren- und Eigentümerinformationen",
  eyebrow: "Kontrollierte Recherche öffentlicher Quellen",
  title: "Investoren und Eigentümersignale entdecken",
  subtitle: "Öffentliche Organisations- und Berufsquellen recherchieren – ohne kostenpflichtige HNWI-Datenbanken oder unbelegte Aussagen zum Privatvermögen.",
  searchPlaceholder: "Investor, Organisation oder Eigentümersignal",
  country: "Zielland",
  profileType: "Investorenprofiltyp",
  allProfileTypes: "Alle Investorenprofiltypen",
  strategy: "Investmentstrategie",
  allStrategies: "Alle Investmentstrategien",
  officialUrl: "Bekannte offizielle Website (optional)",
  search: "Öffentliche Quellen durchsuchen",
  searching: "Suche läuft…",
  contactReady: "Professioneller Kontakt vollständig",
  needsContact: "Professioneller Kontakt fehlt",
  email: "Geprüfte geschäftliche E-Mail",
  phone: "Geprüfte geschäftliche Telefonnummer",
  reviewSource: "Öffentliche Quelle prüfen",
  imported: "Bereits importiert",
  importing: "Wird importiert…",
  import: "Profil importieren",
  searchError: "Die öffentliche Investorensuche ist fehlgeschlagen.",
  importSuccess: "Informationsprofil wurde zur Prüfung importiert.",
  importError: "Informationsprofil konnte nicht importiert werden.",
  ruleOfficial: "Vor dem Import die offizielle Quelle der Organisation oder Fachperson prüfen.",
  ruleContact: "Für den kontrollierten Import sind eine öffentliche geschäftliche E-Mail und Telefonnummer erforderlich.",
  ruleReview: "Entdeckte Daten bleiben bis zur autorisierten Prüfung unverifiziert und für Kontaktaufnahme gesperrt.",
  results: "Kandidaten aus öffentlichen Quellen gefunden",
  provider: "Suchanbieter",
  noResults: "Keine geeigneten öffentlichen Investoren- oder Eigentümerprofile gefunden.",
});

// Investor Italian and Russian overrides.
Object.assign(investorOwnershipTranslations.it, {
  navigation: "Intelligence su Investitori e Proprietà",
  eyebrow: "Intelligence Panatlantik da fonti pubbliche",
  title: "Intelligence su Investitori e Proprietà",
  subtitle: "Profili basati su evidenze di family office, società d’investimento, fondi, investitori istituzionali, proprietari e capitale immobiliare strategico.",
  addProfile: "Aggiungi profilo di intelligence",
  discover: "Scopri profili pubblici",
  total: "Profili totali",
  priorityA: "Profili con priorità A",
  verified: "Verificati ufficialmente",
  portugal: "Interessati al Portogallo",
  search: "Cerca investitore, organizzazione, area o settore…",
  allProfileTypes: "Tutti i tipi di profilo",
  allSectors: "Tutti i settori d’investimento",
  sectors: "Settori d’investimento",
  contactMissing: "Il contatto professionale richiede verifica",
  officialWebsite: "Sito ufficiale",
  portugalPresence: "Interesse d’investimento in Portogallo",
  loading: "Caricamento intelligence investitori…",
  loadError: "Impossibile caricare l’intelligence investitori.",
  noResults: "Nessun profilo di investitore o proprietà trovato.",
  noResultsHelp: "Modificare i filtri o cercare profili nelle fonti pubbliche approvate.",
  noDescription: "Nessuna descrizione da fonte pubblica registrata.",
  notice: "Solo intelligence da fonti pubbliche. Evidenze, base giuridica e stato del contatto devono essere verificati prima di ogni comunicazione.",
});
Object.assign(investorOwnershipTranslations.it.form, {
  eyebrow: "Profilo di intelligence basato su evidenze",
  title: "Aggiungi Profilo Investitore o Proprietà",
  companyInformation: "Informazioni sull’organizzazione e sull’investimento",
  name: "Nome del profilo o dell’organizzazione",
  legalName: "Denominazione legale",
  entityType: "Tipo di entità",
  organisation: "Organizzazione",
  person: "Professionista con ruolo pubblico",
  country: "Paese della sede",
  city: "Città della sede",
  website: "Sito ufficiale",
  role: "Tipo di profilo",
  speciality: "Settore d’investimento",
  capability: "Strategia d’investimento",
  investmentGeography: "Area geografica d’investimento obiettivo",
  description: "Descrizione da fonti pubbliche",
  professionalContact: "Contatto professionale pubblico",
  relevance: "Perché questo profilo è rilevante",
  save: "Salva profilo di intelligence",
  saving: "Salvataggio…",
  created: "Profilo di intelligence investitore creato.",
  createError: "Impossibile creare il profilo di intelligence.",
});
Object.assign(investorOwnershipTranslations.it.discovery, {
  back: "Torna a Intelligence su Investitori e Proprietà",
  eyebrow: "Ricerca controllata su fonti pubbliche",
  title: "Scopri Investitori e Segnali di Proprietà",
  subtitle: "Ricerca fonti pubbliche organizzative e professionali senza database HNWI a pagamento né affermazioni patrimoniali personali non documentate.",
  searchPlaceholder: "Investitore, organizzazione o segnale di proprietà",
  country: "Paese obiettivo",
  profileType: "Tipo di profilo investitore",
  allProfileTypes: "Tutti i tipi di investitore",
  strategy: "Strategia d’investimento",
  allStrategies: "Tutte le strategie d’investimento",
  officialUrl: "Sito ufficiale conosciuto (facoltativo)",
  search: "Cerca fonti pubbliche",
  searching: "Ricerca…",
  contactReady: "Contatto professionale completo",
  needsContact: "Contatto professionale mancante",
  email: "E-mail professionale verificata",
  phone: "Telefono professionale verificato",
  reviewSource: "Verifica fonte pubblica",
  imported: "Già importato",
  importing: "Importazione…",
  import: "Importa profilo",
  searchError: "La ricerca pubblica di investitori non è riuscita.",
  importSuccess: "Profilo di intelligence importato per la verifica.",
  importError: "Impossibile importare il profilo di intelligence.",
  ruleOfficial: "Verificare la fonte ufficiale dell’organizzazione o del professionista prima dell’importazione.",
  ruleContact: "Per l’importazione controllata sono obbligatori e-mail e telefono professionali pubblici.",
  ruleReview: "I risultati restano non verificati e bloccati per il contatto fino alla revisione autorizzata.",
  results: "candidati da fonti pubbliche trovati",
  provider: "Fornitore di ricerca",
  noResults: "Nessun profilo pubblico idoneo di investitore o proprietà trovato.",
});

Object.assign(investorOwnershipTranslations.ru, {
  navigation: "Аналитика инвесторов и собственности",
  eyebrow: "Аналитика Panatlantik из открытых источников",
  title: "Аналитика инвесторов и собственности",
  subtitle: "Подтверждённые данными профили семейных офисов, инвестиционных компаний, фондов, институциональных инвесторов, собственников и стратегического капитала в недвижимости.",
  addProfile: "Добавить аналитический профиль",
  discover: "Найти открытые профили",
  total: "Всего профилей",
  priorityA: "Профили приоритета A",
  verified: "Официально подтверждены",
  portugal: "Интерес к Португалии",
  search: "Поиск инвестора, организации, региона или сектора…",
  allProfileTypes: "Все типы профилей",
  allSectors: "Все инвестиционные секторы",
  sectors: "Инвестиционные секторы",
  contactMissing: "Профессиональный контакт требует проверки",
  officialWebsite: "Официальный сайт",
  portugalPresence: "Инвестиционный интерес к Португалии",
  loading: "Загрузка аналитики инвесторов…",
  loadError: "Не удалось загрузить аналитику инвесторов.",
  noResults: "Профили инвесторов или собственности не найдены.",
  noResultsHelp: "Измените фильтры или найдите профили в одобренных открытых источниках.",
  noDescription: "Описание из открытого источника не зарегистрировано.",
  notice: "Только данные из открытых источников. До любого контакта необходимо проверить доказательства, правовое основание и статус взаимодействия.",
});
Object.assign(investorOwnershipTranslations.ru.form, {
  eyebrow: "Аналитический профиль на основе доказательств",
  title: "Добавить Профиль Инвестора или Собственности",
  companyInformation: "Информация об организации и инвестициях",
  name: "Название профиля или организации",
  legalName: "Юридическое наименование",
  entityType: "Тип субъекта",
  organisation: "Организация",
  person: "Публичный профессионал",
  country: "Страна головного офиса",
  city: "Город головного офиса",
  website: "Официальный сайт",
  role: "Тип профиля",
  speciality: "Инвестиционный сектор",
  capability: "Инвестиционная стратегия",
  investmentGeography: "Целевая география инвестиций",
  description: "Описание из открытых источников",
  professionalContact: "Открытый профессиональный контакт",
  relevance: "Почему этот профиль важен",
  save: "Сохранить аналитический профиль",
  saving: "Сохранение…",
  created: "Аналитический профиль инвестора создан.",
  createError: "Не удалось создать аналитический профиль.",
});
Object.assign(investorOwnershipTranslations.ru.discovery, {
  back: "Назад к аналитике инвесторов и собственности",
  eyebrow: "Контролируемое исследование открытых источников",
  title: "Поиск Инвесторов и Сигналов Собственности",
  subtitle: "Исследование открытых корпоративных и профессиональных источников без платных баз HNWI и неподтверждённых заявлений о личном капитале.",
  searchPlaceholder: "Инвестор, организация или сигнал собственности",
  country: "Целевая страна",
  profileType: "Тип профиля инвестора",
  allProfileTypes: "Все типы инвесторов",
  strategy: "Инвестиционная стратегия",
  allStrategies: "Все инвестиционные стратегии",
  officialUrl: "Известный официальный сайт (необязательно)",
  search: "Искать в открытых источниках",
  searching: "Поиск…",
  contactReady: "Профессиональный контакт заполнен",
  needsContact: "Профессиональный контакт отсутствует",
  email: "Проверенный рабочий e-mail",
  phone: "Проверенный рабочий телефон",
  reviewSource: "Проверить открытый источник",
  imported: "Уже импортирован",
  importing: "Импорт…",
  import: "Импортировать профиль",
  searchError: "Поиск инвесторов в открытых источниках завершился ошибкой.",
  importSuccess: "Аналитический профиль импортирован для проверки.",
  importError: "Не удалось импортировать аналитический профиль.",
  ruleOfficial: "Перед импортом проверьте официальный источник организации или специалиста.",
  ruleContact: "Для контролируемого импорта необходимы открытые рабочие e-mail и телефон.",
  ruleReview: "До авторизованной проверки найденные данные остаются неподтверждёнными и заблокированными для контакта.",
  results: "кандидатов из открытых источников найдено",
  provider: "Поставщик поиска",
  noResults: "Подходящие открытые профили инвесторов или собственности не найдены.",
});

export default investorOwnershipTranslations;
